import { render } from "./PointCloudViewer.vue?vue&type=template&id=622d982a&scoped=true"
import script from "./PointCloudViewer.vue?vue&type=script&lang=js"
export * from "./PointCloudViewer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-622d982a"

export default script